// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-fixed-bottom{position:fixed;bottom:0;right:10px}.btn-fixed-bottom:hover{position:fixed}.case-tickets{height:100%;-webkit-transform:translateX(0);transform:translateX(0);overflow-y:hidden}.case-tickets .btn-tooltip{z-index:1}.ps{height:calc(100vh - 100px)}", ""]);
// Exports
module.exports = exports;
